module.exports = __webpack_public_path__ + "static/media/Template_7.2a08ac3b.png";